import { FetchBreakDurationRulesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

// TODO: I need to totally remove this
export const useFetchBreakDurationRules = (attendanceEmployeesSettingIds: string[]) => {
  const { loading, data, refetch } = useQuery(FetchBreakDurationRulesDocument, {
    variables: { attendanceEmployeesSettingIds },
    skip: !attendanceEmployeesSettingIds.length,
  })

  const breakSettings = data?.attendance.breakSettingsConnection.nodes || []

  return {
    loading,
    breakSettings,
    refetch,
  }
}
